import { Box, Paper, Stack, Typography } from "@mui/material";
import { StratifyDocument } from "@stratify/shared";
import { formatInTimeZone } from "date-fns-tz";
import React from "react";
import { PropertyAddressSelect } from "./PropertyAddressSelect";
import { PropertyStrataPlanSelect } from "./PropertyStrataPlanSelect";

interface DocumentInfoCardProps {
  document: StratifyDocument;
}

export const DocumentInfoCard: React.FC<DocumentInfoCardProps> = ({
  document,
}) => {
  return (
    <Paper sx={{ p: 3 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          mb: 2,
        }}
      >
        <Typography variant="h6">Document Information</Typography>
      </Box>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
        <PropertyAddressSelect document={document} />
        <PropertyStrataPlanSelect document={document} />
        <Stack spacing={1}>
          <Typography variant="subtitle2" color="text.secondary">
            Published Date
          </Typography>
          <Typography data-testid="document-published-date">
            {document.metadata.publishedOn
              ? formatInTimeZone(
                  document.metadata.publishedOn.toDate(),
                  "UTC",
                  "PP"
                )
              : "-"}
          </Typography>
        </Stack>
      </Box>
    </Paper>
  );
};
